import { FalhaServico } from '../falha-servico';

export class ParticipacaoFalencias{
    falhaServico: FalhaServico;
    resultados: Array<Falencia>;

    constructor(){
        this.falhaServico = new FalhaServico();
        this.resultados = [];
    }

}

export class Falencia{
    empresa: string;
    cnpj: string;
    processo: string;
    dataOcorrencia: string;
}
